import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface HelpState {
  isOpen: boolean;
  activeSectionId: string | null;
}

const initialState: HelpState = {
  isOpen: false,
  activeSectionId: null,
};

const helpSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {
    openHelpSidebar: (state, action: PayloadAction<string>) => {
      state.isOpen = true;
      state.activeSectionId = action.payload;
    },
    closeHelpSidebar: (state) => {
      state.isOpen = false;
      state.activeSectionId = null;
    },
  },
});

export const { openHelpSidebar, closeHelpSidebar } = helpSlice.actions;
export default helpSlice.reducer;
